import {ICollectionItemResponseInstance} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/ICollectionItemResponseInstance'
import {CollectionItemType} from '@toolify/server/src/models/mongoose/CollectionItemModel/enum/CollectionItemType'
import {
  ILinkCollectionItemPayload,
} from '@toolify/server/src/services/CollectionService/strategies/LinkCollectionItemTypeStrategy/types/ILinkCollectionItemTypeStrategyInterfaces'

export function getCollectionLinkPayload(item: ICollectionItemResponseInstance): ILinkCollectionItemPayload | null {
  if(item.collectionItemType !== CollectionItemType.Link) {
    return null
  }
  return item.collectionItemTypePayload as ILinkCollectionItemPayload
}
